import React, { useEffect, useState } from "react";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import eth from "../../../../assets/eth.svg";
import polygon from "../../../../assets/matic.svg";

import "./ChooseCrypto.css";

const useStyles = makeStyles((theme) => ({
  heading: {
    fontSize: "20px",
    fontWeight: "600",
  },
  ChooseCryptoContent: {},

  text: {
    fontSize: "18px",
  },
}));

function ChooseCrypto({ data, setData }) {
  const classes = useStyles();

  const [type, setCryptoType] = useState(data.cryptoType);
  // const [opacity, setOpacity] = useState(0.5);
  const clickHandle = (event) => {
    event.preventDefault();
    console.log("You clicked the button");
  };

  useEffect(() => {
    setData({ ...data, cryptoType: type });
  }, [type]);

  return (
    <div
      className="choose-crypto"
      style={{
        marginTop: "50px",
      }}
    >
      <div className="content">
        <Typography class={classes.heading}>Choose Blockchain</Typography>
        <div
          class="chooseCryptoContent"
          style={{ display: "flex", flexDirection: "row" }}
        >
          <div
            className="selected-opacity"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              // opacity: { opacity },
            }}
            onClick={() => setCryptoType("Ethereum")}
          >
            <img
              src={eth}
              style={{
                margin: "10px 20px 0px 20px",
              }}
              alt="eth"
              width="50px"
              className={type === "Ethereum" ? "active" : ""}
            ></img>
            <Typography class={classes.text} variant="h5">
              Ethereum
            </Typography>
          </div>
          <div
            class="chooseCryptoContent"
            style={{ display: "flex", flexDirection: "row" }}
          >
            <div
              className="selected-opacity"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                // opacity: { opacity },
              }}
              onClick={() => setCryptoType("Polygon")}
            >
              <img
                src={polygon}
                style={{
                  margin: "10px 20px 0px 20px",
                }}
                className={type === "Polygon" ? "active" : ""}
                alt="eth"
                width="50px"
              ></img>
              <Typography class={classes.text} variant="h5">
                Polygon
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChooseCrypto;
